module.exports = __webpack_public_path__ + "img/shareTip.3fd6cde8.png";